/** Префикс приложения (PWA start_url / scope). */
export const APP_BASE = '/app';

/**
 * Путь внутри приложения: `appPath('/home')` → `/app/home`.
 * Уже префиксированные пути возвращает как есть.
 */
export function appPath(path = ''): string {
  if (!path || path === '/') return `${APP_BASE}/home`;
  const p = path.startsWith('/') ? path : `/${path}`;
  if (p === APP_BASE || p.startsWith(`${APP_BASE}/`)) return p;
  return `${APP_BASE}${p}`;
}

/** `/app/login?next=...` */
export function appLoginPath(next?: string): string {
  if (!next) return appPath('/login');
  const target = next.startsWith('/') ? next : appPath(next);
  return `${appPath('/login')}?next=${encodeURIComponent(target)}`;
}

/** Безопасный next после логина (только относительные пути сайта). */
export function resolveAfterLoginPath(
  next: string | null | undefined,
  fallback = appPath('/home'),
): string {
  if (!next || !next.startsWith('/') || next.startsWith('//')) return fallback;
  return next;
}
